import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Stack } from '@mui/material';

import { RecipeCard } from '@app/components';
import useResponsive from '@app/hooks/use-responsive';
import { PATH_DASHBOARD } from '@app/routes/paths';
import { selectMyMeals } from '../selectors';

const MyMealsScreen = () => {
  const navigation = useNavigate();

  const myMeals = useSelector(selectMyMeals);

  const isMobile = useResponsive('down', 'md');
  const isTab = useResponsive('down', 'lg');

  const RenderItem = ({ item }: any, key: number) => {
    return (
      <Stack sx={{ borderRadius: '10px', width: isMobile ? '100%' : isTab ? 400 : 550 }}>
        <RecipeCard
          key={key}
          image={item?.image}
          dishName={item.label}
          cookingTime={`${item.totalTime} min`}
          ratings={item?.ratings || 'No Rating Yet'}
          description={item.label || item.description}
          id={item?.uri}
          onClick={() => navigation(PATH_DASHBOARD.recipeDetailsScreen, { state: item })}
        />
      </Stack>
    );
  };
  return (
    <Stack
      style={{
        flexDirection: 'row',
        gap: 15,
        width: isMobile ? '' : '90%',
        flexWrap: 'wrap',
        marginTop: 10,
        alignSelf: 'center',
      }}
    >
      {myMeals?.map((item: any, index: number) => <RenderItem key={index} item={item} />)}
    </Stack>
  );
};

export { MyMealsScreen };
